import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Alert,
  Fade,
} from '@mui/material';
import {
  Error,
  Refresh,
  Home,
} from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

export interface ErrorData {
  data: any;
  resumo?: string;
  url?: string;
  error?: string;
  operation_code?: string;
  status?: string;
  rawResponse?: string;
}

export interface ErrorViewProps {
  errorData: ErrorData;
  onRetry?: () => void;
  onGoHome?: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({
  errorData,
  onRetry,
  onGoHome,
}) => {
  const { data, resumo, url, error, operation_code, status, rawResponse } = errorData;

  return (
    <Fade in timeout={600}>
      <Box sx={{ p: 3, textAlign: 'center' }}>
        {/* Header */}
        <Box sx={{ mb: 3 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: DESIGN_TOKENS.colors.status.error[500],
              mx: 'auto',
              mb: 2,
              fontSize: '2rem',
            }}
          >
            <Error sx={{ fontSize: '2rem' }} />
          </Avatar>
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 700, 
              color: DESIGN_TOKENS.colors.status.error[500],
              mb: 1 
            }}
          >
            Resposta Inesperada
          </Typography>
          <Typography 
            variant="body1" 
            sx={{ 
              color: DESIGN_TOKENS.colors.text.secondary,
              mb: 2
            }}
          >
            A IA retornou uma resposta que não conseguimos processar adequadamente.
          </Typography>
        </Box>

        {/* Error Details */}
        <Card 
          elevation={2} 
          sx={{ 
            mb: 3,
            borderRadius: 3,
            border: `1px solid ${DESIGN_TOKENS.colors.status.error[100]}`,
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600,
                color: DESIGN_TOKENS.colors.status.error[500],
                mb: 2
              }}
            >
              Detalhes da Resposta
            </Typography>
            
            {resumo && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                  <strong>Resumo:</strong> {resumo}
                </Typography>
              </Box>
            )}
            
            {operation_code && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                  <strong>Código da Operação:</strong> {operation_code}
                </Typography>
              </Box>
            )}
            
            {status && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                  <strong>Status:</strong> {status}
                </Typography>
              </Box>
            )}
            
            {url && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
                  <strong>URL:</strong> {url}
                </Typography>
              </Box>
            )}
            

          </CardContent>
        </Card>



        {/* Help Text */}
        <Box sx={{ mt: 3 }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: DESIGN_TOKENS.colors.text.secondary,
              fontStyle: 'italic'
            }}
          >
            Se o problema persistir, tente reformular sua pergunta ou entre em contato com o suporte.
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

export default ErrorView;
export { ErrorView };